export default (pictures = []) => {
  return pictures.find(pic => pic.cover === true) || pictures[0]
}
